"use client";
import { useEffect, useState } from "react";
type User = { id: string; full_name: string; email: string; role: string };
export function AdminLiveView() {
  const [user, setUser] = useState<User | null>(null);
  const [invite, setInvite] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      fetch("/api/auth/session").then((r) => r.json()),
      fetch("/api/users").then((r) => r.json()),
    ])
      .then(([session, list]) => {
        setUser(session.user);
        setUsers(list.users ?? []);
      })
      .finally(() => setLoading(false));
  }, []);
  if (loading)
    return (
      <section className="module-view" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:22:7"}>
        <div className="empty-message" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:23:9"}>Загружаем профиль и пользователей…</div>
      </section>
    );
  if (!user || user.role !== "administrator")
    return (
      <section className="module-view" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:28:7"}>
        <div className="panel empty-route" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:29:9"}>
          <h2 data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:30:11"}>Доступ ограничен</h2>
          <p data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:31:11"}>Раздел пользователей доступен только администраторам.</p>
        </div>
      </section>
    );
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:36:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:37:7"}>
        <div data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:38:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:39:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:40:34"}>/</span> Администрирование
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:42:11"}>Администрирование</h1>
          <p data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:43:11"}>Вы вошли как {user.full_name} · Администратор</p>
        </div>
        <button className="primary-button" onClick={() => setInvite(!invite)} data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:45:9"}>
          + Пригласить сотрудника
        </button>
      </div>
      {invite && (
        <form
          className="panel create-form"
          onSubmit={(event) => {
            event.preventDefault();
            const form = new FormData(event.currentTarget);
            fetch("/api/users", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                fullName: form.get("fullName"),
                email: form.get("email"),
                password: form.get("password"),
                role: form.get("role"),
              }),
            }).then((response) => response.ok && setInvite(false));
          }}
         data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:50:9"}>
          <h2 data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:67:11"}>Новый сотрудник</h2>
          <input name="fullName" required placeholder="Имя сотрудника" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:68:11"} />
          <input name="email" required type="email" placeholder="Рабочая почта" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:69:11"} />
          <input
            name="password"
            required
            minLength={8}
            type="password"
            placeholder="Временный пароль (8+ символов)" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:70:11"}
          />
          <select name="role" defaultValue="manager" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:77:11"}>
            <option value="manager" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:78:13"}>Менеджер</option>
            <option value="administrator" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:79:13"}>Администратор</option>
          </select>
          <button className="primary-button" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:81:11"}>Создать пользователя</button>
        </form>
      )}
      <div className="panel permissions" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:84:7"}>
        <h2 data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:85:9"}>Права текущей сессии</h2>
        <div className="permission-grid" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:86:9"}>
          <span className="allowed" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:87:11"}>✓ Управление пользователями</span>
          <span className="allowed" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:88:11"}>✓ Настройка этапов воронки</span>
          <span className="allowed" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:89:11"}>✓ Полные отчёты отдела</span>
          <span className="allowed" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:90:11"}>✓ Управление всеми клиентами</span>
        </div>
      </div>
      <div className="panel user-list" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:93:7"}>
        <h2 data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:94:9"}>Пользователи команды</h2>
        {users.length === 0 ? (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:96:11"}>Пользователей пока нет.</div>
        ) : (
          users.map((member) => (
            <div className="user-row" key={member.id} data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:99:13"}>
              <div className="avatar avatar-purple" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:100:15"}>{member.full_name.slice(0, 2)}</div>
              <div data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:101:15"}>
                <strong data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:102:17"}>{member.full_name}</strong>
                <span data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:103:17"}>
                  {member.email} · {member.role === "administrator" ? "Администратор" : "Менеджер"}
                </span>
              </div>
              <em className="status status-green" data-amazi-id={"crm/src/features/crm/admin-live-view.tsx:107:15"}>Активен</em>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
